import React, { useEffect } from "react";
import { NavLink, useNavigate, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
// import "../../src/assets/css/bootstrap.min.css";
import "../../src/assets/css/fontawesome-all.min.css";
// import "../../src/assets/css/slick.css";
// import "../../src/assets/css/line-awesome.min.css";
// import "../../src/assets/css/main.css";

import "../../src/assets/stylesheet/bootstrap.min.css";
import "../../src/assets/stylesheet/all-fontawesome.min.css";
import "../../src/assets/stylesheet/animate.min.css";
import "../../src/assets/stylesheet/magnific-popup.min.css";
import "../../src/assets/stylesheet/owl.carousel.min.css";
import "../../src/assets/stylesheet/style.css";

import LogoImage from "../../src/assets/img/logo/logo.png";


// import LogoImage from "../../src/assets/images/all/scan-svgrepo-com 1.svg";



const isActive = (path) => location.pathname === path;

const isHomePage = location.pathname === "/";

const CommonInstituteNew = () => {
    const state = useSelector((state) => state.handleCart);
    const navigate = useNavigate();
    const location = useLocation();

  const user_id = ACCESS_Log_In_User_Id();
  const { id, flags } = useParams();
  const currentUserId = user_id ? user_id : id;
  const flag = "website";  // Example flag parameter
  const encodedUserId = encodeURIComponent(currentUserId);
  const encodedFlag = encodeURIComponent(flag);
  const profileUrl = `${window.location.origin}/instituteProfile/${encodedUserId}/${encodedFlag}`;

    useEffect(() => {
      console.log("Header refreshed on route change:", location.pathname);
      // Add logic here if needed, such as fetching data or resetting state
    }, [location]);


  // Navigate to login
  const handleLoginNavigate = () => {
    navigate("/login"); // Navigate to login screen
  };

  // Log out and refresh page
  const handleLogOutNavigate = () => {
  localStorage.removeItem("ACCESS_TOKEN_NAME"); // Remove token
    navigate("/logOut"); // Navigate to logout route
    window.location.reload(); // Refresh the page
  };

  // Navigate to QR Reader
  const handleNavigateToQRReader = () => {
    navigate("/qrReader"); // Navigate to QR Reader screen
  };


  return (
    <>
    {/* Preloader */}
    {/* <div class="preloader">
        <div class="loader-book">
            <div class="loader-book-page"></div>
            <div class="loader-book-page"></div>
            <div class="loader-book-page"></div>
        </div>
    </div> */}
    <header class="header d-block d-lg-none">
        <div class="main-navigation">
            <nav class="navbar navbar-expand-lg">
                <div class="container position-relative">
                    <a class="navbar-brand" href="/">
                        <img src={LogoImage} alt="logo" />
                    </a>
                    <div class="mobile-menu-right">

                        <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                            data-bs-target="#main_nav" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="navbar-toggler-mobile-icon"><i class="far fa-bars"></i></span>
                        </button>
                    </div>
                    <div class="collapse navbar-collapse" id="main_nav">
                        <ul class="navbar-nav">
                            <li class="nav-item dropdown">
                                <a class="nav-link active" href={profileUrl}>Edit Profile</a>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link" href="/instituteCourse">Your Channel </a>
                            </li>
                            <li class="nav-item mega-menu dropdown mobile_list">
                                {localStorage.getItem("ACCESS_TOKEN_NAME") ? (
                                <a onClick={handleLogOutNavigate} >
                                    <span class="tooltip_bx mobile_view">Logout</span>
                                </a>
                                ) : (
                                    <a onClick={handleLoginNavigate}>
                                    <span class="tooltip_bx mobile_view">Login</span>
                                    </a>
                                )}
                            </li>
                        </ul>


                    </div>
                </div>
            </nav>
        </div>
    </header>
      {/* Mobile Menu */}


      {/* Header */}

    </>
  );
};

export default CommonInstituteNew;

